<template>
  <div class="business-online">
    <website-header :setNum="1"></website-header>
    <div class="index-top display-flex justify-content-center align-items-center" :style="`background-image:url('${imgURI + '/static/business/online/BJ4.png'}');`">
      <div class="def-width display-flex justify-content-end">
        <img class="index-top-img" :src="`${imgURI}/static/business/offline/TX2.png`"/>
      </div>
    </div>
    <div class="index-top-tips">
      <div class="title">线下资源优势</div>
      <div class="title-e">Offline resource advantages</div>
    </div>
    <div class="def-width margin-center">
      <div class="online-nav">品牌曝光</div>
    </div>
    <div class="display-flex justify-content-center">
      <img :src="`${imgURI}/static/business/offline/T4.png`"/>
      <div class="content1 display-flex justify-content-center align-items-center">
        <div>侃侃媒体矩阵全渠道曝光</div>
        <div>线下多类型曝光呈现方式：背板x互动</div>
        <div>联合全行业媒体资源宣发：嘉宾x媒体</div>
      </div>
    </div>
    <div class="def-width margin-center">
      <div class="online-nav">精准获客</div>
    </div>
    <div class="display-flex justify-content-center">
      <div class="content1 display-flex justify-content-center align-items-center text-center">
        <div style="line-height: 30px">垂直跨境领域<br />
          主题活动类型丰富</div>
        <div style="line-height: 30px;margin-top: 20px">可参与多种不同类型活动<br />
          依据观众画像精准获客</div>
      </div>
      <img :src="`${imgURI}/static/business/offline/T5.png`"/>
    </div>
    <div class="def-width margin-center">
      <div class="online-nav">媒体矩阵</div>
    </div>
    <div class="display-flex justify-content-center" style="margin-bottom: 127px">
      <img :src="`${imgURI}/static/business/offline/T6.png`"/>
      <div class="content1 display-flex justify-content-center align-items-center text-center">
        <div>1v多，行业资源一站式链接</div>
        <div>参与市场人多类型体验活动</div>
        <div>深度同频交流，拓展渠道资源</div>
      </div>
    </div>
    <website-bot></website-bot>
  </div>
</template>

<script>
import WebsiteBot from '@/components/public/websiteBot'
import WebsiteHeader from '@/components/public/header'
import config from '@/config/index'
export default {
  name: "businessOffline",
  components: {WebsiteBot, WebsiteHeader},
  data () {
    return {
      imgURI: config.imgURI
    }
  }
}
</script>

<style lang="scss" scoped>
.business-online{
  .index-top{
    margin-top: 100px;
    width: 100%;
    height: 650px;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .index-top-img{
      position: relative;
      z-index: 2;
      width: 1000px;
      height: 420px;
    }
  }
  .index-top-tips{
    z-index: 3;
    position: absolute;
    top: 300px;
    left: 11%;
    width: 600px;
    height: 238px;
    border: 1px solid #FFFFFF;
    color: #FFFFFF;
    .title{
      margin-top: 53px;
      margin-left: 76px;
      font-size: 50px;
    }
    .title-e{
      margin-top: 20px;
      margin-left: 76px;
      font-size: 36px;
      font-weight: lighter;
    }
  }
  .online-nav{
    margin: 112px 0 84px 0;
    padding-left: 24px;
    border-left: 4px solid #386BF3;
    letter-spacing: 4px;
    font-size: 40px;
  }
  .content1{
    width: 460px;
    height: 432px;
    background-image: url("/static/business/online/obg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    flex-direction: column;
    line-height: 50px;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/business/offline.vue